<template>
  <div>
    <!-- 自动任务编辑 -->
    <div class="autoTaskEditing">

      <Head />
      <div class="detail">
        <!-- 到货核查抽查 和 检品操作抽查-->
        <arrival :options="options" :type="type" :adminList="adminList" :executeTypeList="executeTypeList"
          :sparkDetail="sparkDetail" v-if="[1, 2,].includes(type)" />
        <!--   FBA操作抽查（贴标前）贴标中 贴标后-->
        <fbaOperation :options="options" :type="type" :adminList="adminList" :executeTypeList="executeTypeList"
          :sparkDetail="sparkDetail" v-if="[4, 5, 6].includes(type)" />
        <!--  到出货包裹-->
        <pendingShipmentPackages :options="options" :type="type" :adminList="adminList"
          :executeTypeList="executeTypeList" :sparkDetail="sparkDetail" v-if="[7].includes(type)" />
        <!-- 已出货配送单 -->
        <shippedPorder :options="options" :type="type" :adminList="adminList" :executeTypeList="executeTypeList"
          :sparkDetail="sparkDetail" v-if="[8].includes(type)" />
        <!-- 商品退货抽查 -->
        <productReturn :options="options" :type="type" :adminList="adminList" :executeTypeList="executeTypeList"
          :sparkDetail="sparkDetail" v-if="[10].includes(type)" />
        <!-- 商品退货抽查 -->
        <shipmentSite :options="options" :type="type" :adminList="adminList" :executeTypeList="executeTypeList"
          :sparkDetail="sparkDetail" v-if="[9].includes(type)" />

      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/header/detailHeader'
import arrival from './components/arrival'
import fbaOperation from './components/fbaOperation'
import pendingShipmentPackages from './components/pendingShipmentPackages'
import shippedPorder from './components/shippedPorder'
import productReturn from './components/productReturn'
import shipmentSite from './components/shipmentSite'
export default {
  components: {
    Head,
    arrival,
    fbaOperation,
    pendingShipmentPackages,
    shippedPorder,
    productReturn,
    shipmentSite
  },

  data() {
    return {
      adminList: [],
      options: [],
      executeTypeList: [],
      type: 0, // 任务类型
      sparkDetail: {
        start_at: '',
        desc: [],
        end_at: '',
        type: '',
        msg_receive: [],
        org_id: [],
        execute_by_type: '',
        spot_spark_rule: [],
        status: 0,
        switch_status: false,
        execute_by: '',
        id: 0,
        spot_spark_rule: []
      },
    };
  },
  created() {
    // 同组织各工种账号列表
    this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then(res => {
      this.adminList = res.data
    })
    // 分类枚举
    this.$api.spotCheckApi.spotTypeList().then(res => {
      this.options = res.data
    })
    // 执行人
    this.$api.spotCheckApi.executeTypeList().then(res => {
      this.executeTypeList = res.data
    })
    this.$store.dispatch("getOrganizationList");
    // 有type为新增  
    let type = this.$route.query.type
    if (type) {
      this.sparkDetail.type = type - 0
      this.type = type - 0

    }
    let id = this.$route.query.id
    if (id) {
      this.sparkDetail.id = id
      this.sparkList()
    }
  },
  methods: {
    sparkList() {
      this.$api.spotCheckApi.sparkList({ id: this.sparkDetail.id }).then(res => {
        if (res.data.data != false) {
          res.data.data[0].switch_status = res.data.data[0].status ? true : false
          this.sparkDetail = res.data.data[0]
          this.type = this.sparkDetail.type
          this.$forceUpdate()
          console.log(this.sparkDetail);
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.autoTaskEditing {
  min-width: 1910px;

  .detail {
    padding: 24px;
    margin: 24px;
    border-radius: 4px;
    background-color: #F8F8F8;


  }
}
</style>